import auth from './oauth'
import toasted from './toasted'

const HAS_ROLE = 'hasRole'
const PERMIT = 'permit'
const DENY = 'deny'

/**
 * Permet d'avoir une syntaxe de route avec
 * meta:{
 *    auth:'permit' || 'hasRole(ROLE_XXX)'
 * }
 *
 *  Les routes sans rien sont en 'deny'
 */
class AccessControl {
  constructor(input) {
    const withRole = input.match(/hasRole\((.*)\)/)
    if (withRole) {
      this.check = HAS_ROLE
      this.requiredRole = withRole[1]
    } else if (input === PERMIT) {
      this.check = PERMIT
    } else {
      this.check = DENY
    }
  }

  isPermitted() {
    return this.check === PERMIT
  }

  isDenied() {
    return this.check === DENY
  }

  isGranted() {
    const granted = this.check === HAS_ROLE && auth.hasRole(this.requiredRole)
    return granted
  }

  denied() {
    try {
      toasted.error('auth.accessDenied')
    } catch (e) {
      console.log('')
    }
  }
}

/**
 * Création de l'acces control
 */
function computeAccessControl(to) {
  const auth = to.meta.auth
  if (auth) {
    return new AccessControl(auth)
  }

  return new AccessControl(DENY)
}

// une fonction qui permet de gerer les beforeRouteEnter
export default function authorization(to, from, next) {
  const accessControl = computeAccessControl(to)
  if (accessControl.isDenied()) {
    // plain denied
    accessControl.denied()
  } else if (accessControl.isPermitted()) {
    // plain permit
    next()
  } else {
    // user must be logged and role must be checked
    if (to.name == 'user/confirm') {
      if (accessControl.isGranted()) {
        next()
      } else {
        // the authorization level is not reached
        accessControl.denied()
      }
    } else if (auth.loggedWithoutCheckConfirmAuth()) {
      auth.renewAccessToken(() => {
        if (accessControl.isGranted()) {
          next()
        } else {
          // the authorization level is not reached
          accessControl.denied()
        }
      })
    } else {
      auth.requireLogin(to)
    }
  }
}
